module.exports = __webpack_public_path__ + "static/img/mslogo.cfdc9b6.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/mslogo.png
// module id = lgZF
// module chunks = 0